import PropTypes from "prop-types";
import ReactQuill from "react-quill";
//
import EditorToolbar, {
  formats,
  redoChange,
  undoChange,
} from "./EditorToolbar";
import { StyledEditor } from "./styles";
import { useLocales } from "../../locales";
// ----------------------------------------------------------------------

Editor.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  simple: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Editor({
  id = "nightz-quill",
  error,
  value,
  onChange,
  simple = false,
  noToolbar = false,
  maxLength,
  helperText,
  sx,
  ...other
}) {
  const { translate } = useLocales();
  const modules = {
    toolbar: noToolbar ? false : {
      container: `#${id}`,
      handlers: {
        undo: undoChange,
        redo: redoChange,
      },
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true,
    },
    syntax: false,
    clipboard: {
      matchVisual: false,
    },
  };
  return (
    <div>
      <StyledEditor
        sx={{
          ...(error && {
            border: (theme) => `solid 1px ${theme.palette.error.main}`,
          }),
          ...sx,
        }}
      >
        {noToolbar ? null : <EditorToolbar id={id} isSimple={simple} />}
        <ReactQuill
          value={value}
          onChange={(content) => {
            console.log(content)
            if (!maxLength || content.length <= maxLength) onChange(content)
          }}
          modules={modules}
          formats={formats}
          placeholder={translate("eventManager.writeSomethingAwesome")}
          {...other}
        />
      </StyledEditor>

      {helperText && helperText}
    </div>
  );
}
